import React from 'react';

import { useTranslate } from '@lumapps/translations';

import { WIDGET_BASE } from '../../../keys';
import type { BlockClientComputed as BlockClientComputedProps, BlockComponent } from '../../../types';
import type { ClientComputedWidgetTypes } from '../../../types/client-computed';
import { BlockNoResults } from '../BlockNoResults';
import { CLIENT_COMPUTED_RENDERERS } from './client-computed';

/**
 * Block rendering client computed widgets
 */
export const BlockClientComputed: BlockComponent<BlockClientComputedProps> = (props) => {
    const { theme, widget, isMainWidget, legacyWidgetId, properties, widgetType } = props;
    const { translateKey } = useTranslate();
    const Renderer = CLIENT_COMPUTED_RENDERERS[widgetType as ClientComputedWidgetTypes];

    if (Renderer) {
        return (
            <Renderer
                properties={properties}
                uuid={widget.widgetId}
                widgetType={widget.widgetType}
                theme={theme}
                legacyWidgetId={legacyWidgetId}
                isMainWidget={isMainWidget}
            />
        );
    }

    // Client computed not migrated => display not migrated error.
    return <BlockNoResults theme={theme} placeholderText={translateKey(WIDGET_BASE.NOT_MIGRATED)} />;
};
